import React, { useRef } from "react";
import { Language, LicenseUser, RemovedLicenseUser } from "../../Types/types";
import { LicenseTranslation } from "../../Translations/LicenseTranslation";
import { useLanguage } from "../../components/LanguageContext";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router-dom";

type LicenseUsersProps = {
  label: string;
  users: LicenseUser[] | RemovedLicenseUser[];
  isPassword?: boolean;
};
const LicenseUsers: React.FC<LicenseUsersProps> = ({
  label,
  users,
  isPassword = true,
}) => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const t = LicenseTranslation[language as Language];

  const divForPdfRef = useRef(null);
  const handlePrint = useReactToPrint({
    documentTitle: `${label}`,
    removeAfterPrint: true,
  });

  return (
    <div className="overflow-x-auto">
      <div className="mb5 flex justify-between">
        <button
          className="bg-purple text-white mt-4 mb-4 px-4 py-2 rounded font-medium shadow-sm"
          onClick={() => navigate("/licenses-list")}
        >
          {t.licenses}
        </button>
        <button
          className="bg-purple text-white mt-4 mb-4 px-4 py-2 rounded font-medium shadow-sm"
          onClick={() => {
            handlePrint(null, () => divForPdfRef.current);
          }}
        >
          PDF
        </button>
      </div>
      <div ref={divForPdfRef}>
        <h1 className="text-xl font-semibold mb-2 text-center">{label}</h1>
        <table className="min-w-full">
          <thead className="bg-gray-100">
            <tr>
              <th className="py-2 px-4 font-medium text-left">{t.username}</th>
              {isPassword && (
                <th className="py-2 px-4 font-medium text-left">
                  {t.password}
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {users.map((user, index) => (
              <tr
                key={index}
                className={`${
                  index !== users.length - 1 ? "border-b border-gray-300" : ""
                }`}
              >
                <td
                  className={`py-2 px-4 text-left font-extralight bg-white dark:bg-darkSecondaryBackground ${
                    index === 0 ? "rounded-tl-md" : ""
                  } ${index === users.length - 1 ? "rounded-bl-md" : ""}`}
                >
                  {user.username}
                </td>
                {isPassword && (
                  <td
                    className={`py-2 px-4 text-right flex font-extralight space-x-2 items-center bg-white dark:bg-darkSecondaryBackground ${
                      index === 0 ? "rounded-tr-md" : ""
                    } ${index === users.length - 1 ? "rounded-br-md" : ""}`}
                  >
                    {(user as LicenseUser).password}
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LicenseUsers;
